import React from 'react';
import About from '../../components/About';

const AboutPage = props => {
  return (
    <>
      <About />
    </>
  );
};

export default AboutPage;